/* eslint-disable no-irregular-whitespace */
import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const SaleModal: React.FC = () => {
  return (
    <div className={styles['container']}>
      <ArticleHeading2>Продажа</ArticleHeading2>

      <ArticleParagraph1>Обычно риелторы работают за процент от суммы продажи — 1,5–3%.</ArticleParagraph1>
      <ArticleParagraph1>
        Процент зависит от сложности сделки: обычная продажа — дешевле. Альтернативные сделки, срочность, нестандартные
        условия — дороже
      </ArticleParagraph1>
      <ArticleParagraph1>
        Агенты часто дают скидку, если вы пользуетесь их услугами и для продажи жилья, и для покупки нового.
      </ArticleParagraph1>
    </div>
  );
};
